import React from "react";
import WatchPartyList from "./WatchPartyList";

const WatchPartiesPage: React.FC = () => {
  return (
    <div className="flex-1 bg-gray-950 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <WatchPartyList />
      </div>
    </div>
  );
};

export default WatchPartiesPage;
